<template>
    <button class="w-full border border-primary hover:border-gray-300 rounded-[4px] hover:bg-gray-300">
        <slot />
    </button>
</template>
